import React from 'react';
export function CTASection() {
  return <section className="mb-16" data-id="element-9">
      <div className="bg-teal-600 text-white p-8 rounded-lg text-center" data-id="element-10">
        <p className="text-lg mb-6" data-id="element-11">
          Right now you can save <strong data-id="element-12">$41 off</strong> the full price of the{' '}
          <strong data-id="element-13">
            <a href="https://www.neurotoned.com/41-off-neuro" className="text-white hover:text-gray-100" data-id="element-14">
              30-Day Neurotoned Vagus Nerve Reset
            </a>
          </strong>{' '}
          — this offer is only available through this page.
        </p>
        <p className="text-lg mb-6" data-id="element-15">
          It also comes with a full money-back guarantee, so you can try it with
          no risk.
        </p>
        <a href="https://www.neurotoned.com/41-off-neuro" className="inline-block bg-white text-teal-700 font-bold py-4 px-8 rounded-lg text-xl shadow-lg hover:bg-gray-100 transition-colors mb-8" data-id="element-16">
          Begin Your Reset
        </a>
        <p className="text-lg mb-6" data-id="element-17">
          Spots often fill quickly, and this special savings may not last
        </p>
        <p className="text-lg mb-8" data-id="element-18">
          You are not broken. You are not failing. And your body is not beyond
          help.
        </p>
        <p className="text-lg mb-8" data-id="element-19">
          Sometimes it just needs the right support to come out of survival —
          and finally return to rest.
        </p>
        <a href="https://www.neurotoned.com/41-off-neuro" className="inline-block bg-white text-teal-700 font-bold py-4 px-8 rounded-lg text-xl shadow-lg hover:bg-gray-100 transition-colors" data-id="element-20">
          Begin Your Reset
        </a>
      </div>
    </section>;
}